import { lazy } from 'react';

export const RequestsAsync = lazy(() => import('./requests.component'));
